/*
  Kumpel Leo – Produktkarten (Datei: assets/kl-karten.js)
  Eingebunden in layout/theme.liquid im <head> mit defer, gilt auf allen Seiten.
  1) Wieder-Da-Service direkt von der Produktkarte: Anmelde-Fenster (wird beim ersten Öffnen erzeugt),
     gleicher Ablauf und gleiche Schnittstelle wie auf der Produktseite.
  2) Zustands-Erklärung auf den Produktkarten (nur Desktop).
  3) Ganze Karte anklickbar: ein Klick irgendwo auf der Karte führt zum Artikel –
     außer auf Links (Marke), Knöpfe ("Benachrichtige mich", Zustands-Symbol am Desktop) und Eingabefelder.
*/
  /* Kumpel Leo – Wieder-Da-Service direkt von der Produktkarte (gleicher Ablauf wie auf der Produktseite) */
  (function () {
    if (window.klwBereit) return;
    window.klwBereit = true;
    var pid = '';
  var KLW_FENSTER = [
    '<div id="klw-ov" role="dialog" aria-modal="true" aria-labelledby="klw-h">',
    '<div id="klw-box">',
    '<button type="button" id="klw-x" aria-label="Schließen">&times;</button>',
    '<div id="klw-form">',
    '<h3 id="klw-h">Wieder-Da-Service</h3>',
    '<p class="klw-sub">Trag dich ein – wir benachrichtigen dich kostenlos, sobald dieser Kumpel wieder verfügbar ist.</p>',
    '<div id="klw-prod"></div>',
    '<p class="klw-preis-hinweis">Die Preisangabe ist unverbindlich und kann sich bei erneuter Verfügbarkeit ändern.</p>',
    '<div class="klw-f">',
    '<label for="klw-vorname">Vorname *</label>',
    '<input type="text" id="klw-vorname" autocomplete="given-name">',
    '</div>',
    '<div class="klw-f">',
    '<label for="klw-nachname">Nachname</label>',
    '<input type="text" id="klw-nachname" autocomplete="family-name">',
    '</div>',
    '<div class="klw-f">',
    '<label for="klw-email">E-Mail *</label>',
    '<input type="email" id="klw-email" autocomplete="email">',
    '</div>',
    '<button type="button" id="klw-send">Benachrichtige mich</button>',
    '<p id="klw-consent">Ja, ich möchte per Mail informiert werden, sobald das hier vorgestellte Produkt wieder verfügbar ist. Meine oben eingetragene Mailadresse wird ausschließlich für die Verfügbarkeitsbenachrichtigung verwendet und nicht an Dritte weitergegeben. Meine Einwilligung kann ich jederzeit mit Wirkung für die Zukunft widerrufen. Die <a href="https://www.kumpel-leo.de/policies/privacy-policy" target="_blank" rel="noopener">Datenschutzerklärung</a> mit weiteren Details habe ich zur Kenntnis genommen.</p>',
    '<div id="klw-msg"></div>',
    '</div>',
    '<div id="klw-ok">',
    '<div class="klw-i">&#10003;</div>',
    '<p>Fast geschafft – bitte bestätige die E-Mail, die wir dir gerade geschickt haben.</p>',
    '</div>',
    '</div>',
    '</div>'
  ].join('\n');
    function el(id) { return document.getElementById(id); }
    function oeffnen(pill) {
      if (!el('klw-ov')) document.body.insertAdjacentHTML('beforeend', KLW_FENSTER);
      var ov = el('klw-ov');
      if (!ov) return;
      pid = pill.getAttribute('data-pid') || '';
      el('klw-prod').textContent = pill.getAttribute('data-titel') || '';
      el('klw-form').style.display = '';
      el('klw-ok').style.display = 'none';
      el('klw-msg').className = ''; el('klw-msg').textContent = '';
      var send = el('klw-send'); send.disabled = false; send.textContent = 'Benachrichtige mich';
      ov.classList.remove('klw-closing');
      ov.classList.add('klw-on');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { el('klw-vorname').focus(); }, 50);
    }
    function ausblenden() {
      el('klw-ov').classList.remove('klw-on', 'klw-closing');
      document.body.style.overflow = '';
    }
    function schliessen() {
      var ov = el('klw-ov'), box = el('klw-box');
      if (window.matchMedia('(max-width:600px)').matches) {
        ov.classList.add('klw-closing');
        var fertig = function () { box.removeEventListener('transitionend', fertig); ausblenden(); };
        box.addEventListener('transitionend', fertig);
        setTimeout(fertig, 320);
      } else {
        ausblenden();
      }
    }
    function err(t) { var m = el('klw-msg'); m.textContent = t; m.className = 'klw-err'; }
    document.addEventListener('click', function (e) {
      var pill = e.target.closest('.klw-pill');
      if (pill) { e.preventDefault(); e.stopPropagation(); oeffnen(pill); return; }
      if (e.target.closest('#klw-x')) { e.preventDefault(); schliessen(); return; }
      if (e.target.closest('#klw-send')) { e.preventDefault(); senden(); }
    }, true);
    document.addEventListener('keydown', function (e) {
      var pill = e.target.closest && e.target.closest('.klw-pill');
      if (pill && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); oeffnen(pill); return; }
      var ov = el('klw-ov');
      if (e.key === 'Escape' && ov && ov.classList.contains('klw-on')) schliessen();
    });
    function senden() {
      var send = el('klw-send');
      var vorname = el('klw-vorname').value.trim();
      var nachname = el('klw-nachname').value.trim();
      var email = el('klw-email').value.trim();
      el('klw-msg').className = ''; el('klw-msg').textContent = '';
      if (!vorname) { err('Bitte gib deinen Vornamen ein.'); return; }
      if (!email || email.indexOf('@') === -1) { err('Bitte gib eine gültige E-Mail-Adresse ein.'); return; }
      if (!pid) { err('Es ist ein Fehler aufgetreten. Bitte versuche es erneut.'); return; }
      send.disabled = true;
      send.textContent = 'Wird gesendet …';
      fetch('https://app.kumpel-leo.de/api/backinstock/registrieren', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ produkt_pid: pid, email: email, vorname: vorname, nachname: nachname || null })
      })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.ok) {
          el('klw-form').style.display = 'none';
          el('klw-ok').style.display = 'block';
        } else {
          err((d && d.fehler) || 'Es ist ein Fehler aufgetreten. Bitte versuche es erneut.');
          send.disabled = false; send.textContent = 'Benachrichtige mich';
        }
      })
      .catch(function () {
        err('Verbindungsfehler – bitte versuche es erneut.');
        send.disabled = false; send.textContent = 'Benachrichtige mich';
      });
    }
  })();

  /* Kumpel Leo – Zustands-Erklärung auf den Produktkarten */
  (function () {
    if (window.klKzBereit) return;
    window.klKzBereit = true;
    function zu() {
      document.querySelectorAll('.kl-kz-info:not([hidden])').forEach(function (i) { i.classList.remove('kl-kz-auf'); i.hidden = true; });
      document.querySelectorAll('.kl-karte-zustand-ico[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    function umschalten(btn) {
      var info = btn.parentNode.querySelector('.kl-kz-info');
      if (!info) return;
      var war = !info.hidden;
      zu();
      if (war) return;
      info.hidden = false;
      void info.offsetWidth;
      info.classList.add('kl-kz-auf');
      btn.setAttribute('aria-expanded', 'true');
    }
    function desktop() { return window.innerWidth >= 990; }
    document.addEventListener('click', function (e) {
      if (!desktop()) return; /* Handy: Symbol ohne Erklärung, ein Tipp führt wie das Bild zum Artikel */
      if (e.target.closest('.kl-kz-info')) { e.preventDefault(); e.stopPropagation(); return; }
      var btn = e.target.closest('.kl-karte-zustand-ico[role="button"]');
      if (btn) { e.preventDefault(); e.stopPropagation(); umschalten(btn); return; }
      zu();
    }, true);
    document.addEventListener('keydown', function (e) {
      var btn = e.target.closest && e.target.closest('.kl-karte-zustand-ico[role="button"]');
      if (btn && desktop() && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); umschalten(btn); return; }
      if (e.key === 'Escape') zu();
    });
  })();

  /* Ganze Karte anklickbar */
  (function () {
    if (window.klKarteKlickBereit) return;
    window.klKarteKlickBereit = true;
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented) return;
      var karte = e.target.closest('.product-card-wrapper');
      if (!karte) return;
      if (e.target.closest('a, button, input, select, textarea, label, [role="button"], modal-opener, .kl-kz-info')) return;
      if (window.getSelection && String(window.getSelection()).length > 0) return; /* Text markiert: nicht wegspringen */
      var link = karte.querySelector('.card-heading a[href]');
      if (!link) return;
      if (e.ctrlKey || e.metaKey || e.button === 1) { window.open(link.href, '_blank'); return; }
      window.location.href = link.href;
    });
  })();